export const PROFILE_LOAD = '@profile/load';
export const PROFILE_SAVE_ANSWER = '@profile/save-answer';
